import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Home from './home'
import Login from './login'
import LoginEmail from './loginEmail'
import Company from './company'
import Branch from './branch'
import Sector from './sector'
import Role from './role'
import User from './user'
import Dimension from './dimension'
import Ask from './ask'
import Research from './research'
import ActionPlan from './actionPlan'
import Analisis from './analisis'
import Extract from './extract'

//Basics
import Disclosure from './disclosure'

//Worker
import HomeWorker from './homeWorker.js'
import ActionPlanWorker from './actionPlanWorker.js'

//Super Admin
import RequestAccess from './requestAccess.js'

//Firts Steps
import FirstSteps from './firstSteps.js'

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "",
    hashbang: false,
    routes: [
        Login,
        LoginEmail,
        Home,
        Company,
        Branch,
        Sector,
        Role,
        User,
        Dimension,
        Ask,
        Research,
        ActionPlan,
        Analisis,
        Extract,

        //Basics
        Disclosure,

        //Worker
        HomeWorker,
        ActionPlanWorker,

        //Super Admin
        RequestAccess,

        //First Steps
        FirstSteps
    ]
});

router.beforeEach((to, from, next) => {

    const authenticated = localStorage.getItem('token');
    const type_id = localStorage.getItem('type_id');

    if (!authenticated && (to.path.toString() != '/login' && to.path.toString() != '/login-email')) {
        console.log(to.path.toString())
        next(store.getters.loginRoute);

        return true;
    }

    if (authenticated && (to.path.toString() == '/login' || to.path.toString() == '/login-email')) {

        next('/');

        return true;
    }

    if (to.path.toString() != '/login' && to.path.toString() != '/login-email') {
        //Persisting routes permition
        const type_id = localStorage.getItem('type_id');

        let routeSplited = to.path.toString().split('/')
        routeSplited = routeSplited.filter(x => x != '')
        console.log(routeSplited)

        console.log(to.path,type_id)
        if(to.path == '/' && type_id != 1 ){
            next('/worker');
            return true;
        }

        if (routeSplited.length && type_id == 1 && routeSplited[0] == 'worker') {
            next('/');
        } else if (type_id == 2) {
            if (!routeSplited.length || routeSplited[0] != 'worker') {
                console.log('h')
                next('/worker');
            }
        }
        else if (type_id == 3) {
            if (!routeSplited.length || routeSplited[0] != 'worker') {
                next('/worker');
            }
        }
        else if (type_id == 4) {
            if (!routeSplited.length || routeSplited[0] != 'requestAccess') {
                next('/requestAccess');
            }
        }
    }

    next();
});

router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js